export const name = 'warmupData' as const

export const WarmupDataEnricherSymbol = Symbol('WarmupDataEnricher')
export const WarmupDataProviderSymbol = Symbol('WarmupDataProvider')
export const WarmupDataAggregatorSymbol = Symbol('WarmupDataAggregator')
export const WarmupDataPromiseSymbol = Symbol('WarmupDataPromise')
export const WarmupDataServiceStoreSymbol = Symbol('WarmupDataServiceStore')

export const WARMUP_DATA_SERVICE_DATA_KEY = 'builderComponentsWarmupData' as const
